import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../../theme';

import { IIndividualFormData } from '../../../services/interfaces';
import StandardInputComponent from '../../form-elements/standard-input';
import LockedStandardInputComponent from '../../form-elements/locked-standard-input';
import SelectMenuComponent from '../../form-elements/select-menu';
import CheckboxInputComponent from '../../form-elements/checkbox-input';
import SubmitButton from '../../form-elements/submit-button';
import { loadUserDetails, updateUserProfile } from '../../../store/users/actions';
import { setAppLoadingState } from '../../../store';

import { timezones } from '../account-form-utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
    },
    formContainers: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    base: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center',
    },
    inputBase: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: '5px',
    },
    inputBaseHalf: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      width: '50%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: '5px',
    },
    submitButton: {
      fontSize: '2em',
    },
  }),
);

export default function EditIndividualAccount(photoUrl: any) {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const profile = useSelector((state: any) => state.user.profile);
  const currUser = useSelector((state: any) => state.auth.currUser);
  const defaultFormValues: IIndividualFormData = {
    displayName: '',
    password: '',
    confirmPass: '',
    email: '',
    contactEmail: '',
    timezone: '',
    referal: '',
    agreeTermsConditions: false,
    photoUrl: null,
    sortPreference: 'all',
    ...profile,
  };

  const [formValues, setFormValues] = useState(defaultFormValues);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (prop: any) => (event: any) => {
    setFormValues({ ...formValues, [prop]: event.target.value });
  };

  const handleCheckChange = (event: any) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.checked });
  };
  useEffect(() => {
    setFormValues({ ...formValues, photoUrl: photoUrl.photoUrl || null });
  }, [photoUrl]);
  const cancelSubmit = async () => {
    console.log('Cancel form');
    setFormValues(defaultFormValues);
  };

  const handleSubmit = async () => {
    console.log('Submit form');
    console.log(formValues);
    setAppLoadingState(dispatch, true);
    await updateUserProfile(currUser, formValues)
      .catch((err) => {
        setErrorMessage(err);
      });
    dispatch(await loadUserDetails(currUser.uid));
    setTimeout(
      () => setAppLoadingState(dispatch, false),
      500);
  };
  return (
    <>
      <Grid item container>
          <Grid item xs={12} md={6} className={classes.formContainers}>
            <FormControl variant="filled" className={classes.inputBase}>
              <StandardInputComponent
                id="username"
                label="Username"
                value={formValues.displayName}
                onChange={handleChange('displayName')}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} className={classes.formContainers}>
            <FormControl variant="filled" className={classes.inputBase}>
              <LockedStandardInputComponent
                id="email"
                label="Sign up / Sign in email"
                value={formValues.email}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} className={classes.formContainers}>
            <FormControl variant="filled" className={classes.inputBase}>
              <StandardInputComponent
                id="first-name"
                label="First Name"
                value={formValues.firstName}
                onChange={handleChange('firstName')}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} className={classes.formContainers}>
            <FormControl variant="filled" className={classes.inputBase}>
              <StandardInputComponent
                id="email"
                label="Contact Email"
                value={formValues.contactEmail}
                onChange={handleChange('contactEmail')}
              />
            </FormControl>
          </Grid>
        <Grid item xs={6} className={classes.formContainers}>
          {/* <FormControl variant="filled" className={classes.inputBase}>
            <PasswordInputComponent
              onChange={handleChange('password')}
              id="password"
              label="Password"
              value={formValues.password}
            />
          </FormControl>

          <FormControl variant="filled" className={classes.inputBase}>
            <PasswordInputComponent
              onChange={handleChange('confirmPass')}
              id="confirm-password"
              label="Confirm Password"
              value={formValues.confirmPass}
            />
          </FormControl> */}
          {/*
          <FormControl variant="filled" className={classes.inputBase}>
            <StandardInputComponent
              id="email"
              label="Email"
              value={formValues.email}
              onChange={handleChange('email')}
            />
          </FormControl> */}
          <FormControl variant="filled" className={classes.inputBase}>
            <StandardInputComponent
              id="last-name"
              label="Last Name"
              value={formValues.lastName}
              onChange={handleChange('lastName')}
            />
          </FormControl>

          <FormControl variant="filled" className={classes.inputBase}>
            <SelectMenuComponent
              id="timezone"
              label="Timezone"
              value={formValues.timezone}
              onChange={handleChange('timezone')}
            >
              <option aria-label="None" value="" />
              {timezones.map(timezone => (
                <option aria-label={timezone} value={timezone}>
                  {timezone}
                </option>
              ))}

            </SelectMenuComponent>
          </FormControl>

          <FormControl variant="filled" className={classes.inputBase}>
            <SelectMenuComponent
              id="referal"
              label="How did you hear about us?"
              value={formValues.referal}
              onChange={handleChange('referal')}
            >
              <option aria-label="None" value="" />
              <option aria-label="Facebook" value="Facebook">Facebook</option>
              <option aria-label="Instagram" value="Instagram">Instagram</option>
              <option aria-label="App" value="App">App</option>
              <option aria-label="Website" value="Website">Website</option>
              <option aria-label="Friend/Family" value="Relation">Friend/Family</option>
              <option aria-label="Church" value="Church">Church</option>
              <option aria-label="Conference" value="Conference">Conference</option>
              <option aria-label="Other" value="Other">Other</option>
            </SelectMenuComponent>
          </FormControl>
        </Grid>

        <Grid item xs={6} className={classes.formContainers}>
          {/* <FormControl variant="filled" className={classes.inputBase}>
            <StandardInputComponent
              id="admin-photo"
              label="Photo Url"
              value={formValues.photoUrl}
              onChange={handleChange('photoUrl')}
            />
          </FormControl>

          <FormControl variant="filled" className={classes.inputBase}>
            <SelectMenuComponent
              id="sort-preference"
              label="Change Default for Sort"
              value={formValues.sortPreference}
              onChange={handleChange('sortPreference')}
            >
              <option aria-label="all" value="all">All Posts</option>
              <option aria-label="public-group" value="public-group">Pulbic Group Posts</option>
              <option aria-label="closed-group" value="closed-group">Closed Group Posts</option>
              <option aria-label="posted" value="posted">Posted</option>
              <option aria-label="not-posted" value="not-Posted">Not Posted</option>
              <option aria-label="group-event" value="group-event">
                Group, Event, Study, Series, Topic, ...
              </option>
              <option aria-label="post-links" value="post-links">Posts with Links</option>
              <option aria-label="post-videos" value="post-videos">Posts with Videos</option>
            </SelectMenuComponent>
          </FormControl> */}
        </Grid>

        <Grid item xs={6}>

        </Grid>

        <Grid item xs={6}>
          {!formValues.agreeTermsConditions &&
          <FormControl className={classes.base}>
            <CheckboxInputComponent
              name="agreeTermsConditions"
              value={formValues.agreeTermsConditions}
              label="I have read and agree to the Terms and Conditions."
              onChange={handleCheckChange}
              variant="light"
            />
          </FormControl>}
        </Grid>
      </Grid>

      <Grid item container>
        <Grid item xs={12} md={6} className={classes.formContainers}>
          <SubmitButton
            className={classes.submitButton}
            onClick={cancelSubmit}
            text="Cancel"
            variant="light"
          />
        </Grid>

        <Grid item xs={12} md={6} className={classes.formContainers}>
          <SubmitButton
            className={classes.submitButton}
            onClick={handleSubmit}
            text="Save"
            variant="light"
          />
        </Grid>
      </Grid>

      <Grid item>
        {errorMessage}
      </Grid>
    </>
  );
}
